import { render } from "./SocialIconColor.vue?vue&type=template&id=161fbc6e"
import script from "./SocialIconColor.vue?vue&type=script&lang=js"
export * from "./SocialIconColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__